/**
 * Generates a random string of 10 characters.
 * @returns {string}
 */
export default function randomId(): string {
  return Math.random()
    .toString(36)
    .substring(2)
}
